import React from "react";
import styled, { keyframes } from "styled-components";

const EmptyState = ({ message, actionLabel, action, illustration }) => {
  return (
    <EmptyStateWrapper>
      <ContentContainer>
        <IllustrationWrapper>
          {illustration ? (
            illustration
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="120"
              height="120"
              viewBox="0 0 24 24"
              fill="none"
              stroke="url(#gradient)"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <defs>
                <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="#E0E8F0" />
                  <stop offset="100%" stopColor="#B0BEC5" />
                </linearGradient>
              </defs>
              <path d="M21 10v10a2 2 0 01-2 2H5a2 2 0 01-2-2V10M23 10H1M12 14v6M8 14v1M16 14v1" />
              <path d="M12 10V3a1 1 0 011-1h2a1 1 0 011 1v3" />
            </svg>
          )}
        </IllustrationWrapper>

        <MessageWrapper>
          <Message>{message}</Message>
        </MessageWrapper>

        {action && actionLabel && (
          <ButtonWrapper>
            <ActionButton onClick={action}>
              {actionLabel}
            </ActionButton>
          </ButtonWrapper>
        )}
      </ContentContainer>
    </EmptyStateWrapper>
  );
};

// Animations
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

// Styled Components
const EmptyStateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  width: 100%;
  text-align: center;
  background: linear-gradient(to bottom, #ffffff, #f7f9fc);
  padding: 40px 20px;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 10, 20, 0.03);
  border: 1px solid #f0f4f8;
  overflow: hidden;
  position: relative;
  animation: ${fadeIn} 0.5s ease-out forwards;
`;

const ContentContainer = styled.div`
  max-width: 450px;
  width: 100%;
`;

const IllustrationWrapper = styled.div`
  margin-bottom: 24px;
  
  svg {
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.05));
  }
`;

const MessageWrapper = styled.div`
  margin-bottom: 32px;
`;

const Message = styled.h3`
  font-size: 22px;
  font-weight: 600;
  color: #42526E;
  margin-bottom: 8px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

const ActionButton = styled.button`
  background: linear-gradient(135deg, #2684FF, #0065FF);
  color: white;
  font-size: 16px;
  font-weight: 500;
  padding: 12px 32px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  box-shadow: 0 2px 4px rgba(38, 132, 255, 0.2);
  
  &:hover {
    background: linear-gradient(135deg, #4C9AFF, #2684FF);
    box-shadow: 0 4px 8px rgba(38, 132, 255, 0.3);
    transform: translateY(-1px) scale(1.03);
  }
  
  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(38, 132, 255, 0.3);
  }
  
  &:active {
    transform: translateY(1px) scale(0.98);
  }
`;

export default EmptyState;